import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import axios from 'axios';

const HubspotCallback = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const code = urlParams.get('code');
    const state = urlParams.get('state');

    if (!code) {
      toast.error('Missing authorization code from HubSpot');
      return navigate('/myconnections');
    }

    const handleCallback = async () => {
      try {
        const res = await axios.post(
          `${process.env.REACT_APP_API_URL}/api/v1/oauth/hubspot/callback`,
          { code, state }
        );

        if (res.data && res.data.access_token) {
          toast.success('HubSpot connected successfully!');
          navigate('/myconnections');
        } else {
          toast.warn('HubSpot connected, but no access token found.');
          navigate('/myconnections');
        }
      } catch (error) {
        console.error(error);
        toast.error('HubSpot connection failed');
        navigate('/myconnections');
      }
    };

    handleCallback();
  }, [navigate]);

  return <div>Connecting your HubSpot account...</div>;
};

export default HubspotCallback;

